import React from 'react';
import SlidingSideBar from '../SlidingSideBar/SlidingSideBar';
import CreateInventory from './CreateInventory';

const CreateSideBar = ({ show, onHide, appChoices, onInventoryAdd, prefillUnit, isDuplicating, refetchChoices }) => {
  return (
    <SlidingSideBar fullScreen visible={show} onClose={onHide} title={'New Inventory Unit'}>
      {show && (
        <CreateInventory
          appChoices={appChoices}
          onInventoryAdd={onInventoryAdd}
          prefillUnit={prefillUnit}
          isDuplicating={isDuplicating}
          refetchChoices={refetchChoices}
        />
      )}
    </SlidingSideBar>
  );
};

export default CreateSideBar;
